export const useRound = () =>
    (number, decimals = 0) => +(Math.round(number + 'e+' + decimals) + 'e-' + decimals);
